/**
 * Dependencies
 */

import { styled } from '@material-ui/styles';

/**
 * Define style
 */

const HeaderH2 = styled('h2')({
  // display: 'inline',
  // width: '100vh',
  // textAlign: 'center',
  // backgroundColor: 'grey',
  // padding: '10px 0px',
  // color: 'white',
  // zIndex: '10px',
  // position: 'absolute',
  // height:"65px"
  textAlign: 'center',
  padding: '10px 0px',
  color: 'white',
  border: '1px solid red'
});

/**
 * Export style
 */

export default HeaderH2;
